import { render, staticRenderFns } from "./success.vue?vue&type=template&id=2b3ee3ce&scoped=true&"
import script from "./success.vue?vue&type=script&lang=js&"
export * from "./success.vue?vue&type=script&lang=js&"
import style0 from "./success.vue?vue&type=style&index=0&id=2b3ee3ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3ee3ce",
  null
  
)

component.options.__file = "success.vue"
export default component.exports